import axios from "@/plugins/axios";

let url = "/api/v1/me/stocks/dashboard";

export const dashboard = {
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default dashboard;
